import Icon from "hardcover-ui/components/Icon";
import faTiktok from "icons/brands/tiktok.svg";
import faLink from "icons/regular/link.svg";

export default function ExternalLinkIcon({ url, size }) {
  if (!url) {
    return <></>;
  }

  if (url.indexOf("tiktok.com") !== -1) {
    return <Icon icon={faTiktok} size={size} />;
  }

  return <Icon icon={faLink} size={size} />;
}
